import withTheme from './withTheme.jsx';
import { adminTheme } from '../theme/adminTheme';

const withAdminTheme = withTheme(adminTheme);
export default withAdminTheme;